import { BankNames } from '@/constants';
import VectorIcon from '@/media/icons/info_user.svg?react';
import Vector from '@/media/icons/lk_client.svg?react';
import Parseint from '@/media/icons/percent.svg?react';

import { EU_TARIFF_TYPES } from '../constants';
import type {
  CreateAutoCreditProps,
  DocumentsInterface,
  FirstStepType,
  SecondStepType
} from './types/form-types';

export const REQUIRED_FIELDS: [
  Array<keyof FirstStepType>,
  Array<keyof SecondStepType>,
  Array<keyof DocumentsInterface>
] = [
  [
    // First step fields
    'dealer',
    'autoType',
    'markModelYear',
    'costCar',
    'initialPayment',
    'loanTerm',
    'engineType',
    'paymentScheme'
  ],
  [
    // Second step fields
    'birthDate',
    'documentType',
    'gender',
    'marriageStatus',
    'childrenCount',
    'companyName',
    'companyType',
    'jobTitle',
    'jobAddress',
    'salary',
    'additionalSalary',
    'workPhoneNumber',
    'socialStatus',
    'contactName',
    'contactPhone',
    'contactType'
  ],
  [
    // Third step fields
    'noticeActivity',
    'docScanSocialStatus',
    'clientPhoto',
    'docPhoto',
    'incomeCert',
    'otherDoc'
  ]
];

export const NOT_REQUIRED_FIELDS: [
  Array<keyof FirstStepType>,
  Array<keyof SecondStepType>,
  Array<keyof DocumentsInterface>
] = [['proofInCome'], [], []];

export const stepCountItemsData: {
  title: string;
  titleMobile: string;
  totalFields: number;
  validFields: number;
  icon: React.ReactNode;
}[] = [
  {
    title: 'Информация о продукте',
    titleMobile: 'Продукт',
    totalFields: REQUIRED_FIELDS[0].length + NOT_REQUIRED_FIELDS[0].length,
    validFields: 0,
    icon: <Parseint />
  },
  {
    title: 'Личная информация',
    titleMobile: 'Личная',
    totalFields: REQUIRED_FIELDS[1].length + NOT_REQUIRED_FIELDS[1].length,
    validFields: 0,
    icon: <Vector />
  },
  {
    title: 'Доп. информация',
    titleMobile: 'Доп.Инфо',
    totalFields: REQUIRED_FIELDS[2].length + NOT_REQUIRED_FIELDS[2].length,
    validFields: 0,
    icon: <VectorIcon />
  }
];

export const defaultAutoCreditValues: CreateAutoCreditProps = {
  dealer: '',
  autoType: '',
  markModelYear: {
    brand: undefined,
    model: undefined,
    year: ''
  },
  costCar: '',
  initialPayment: '',
  loanTerm: '',
  engineType: '',
  engineCapacity: '',
  paymentScheme: '',
  proofInCome: false,
  eurasianTariffType: EU_TARIFF_TYPES.STANDARD,
  stockBounds: [],
  additionalProducts: [],

  birthDate: '',
  documentType: '',
  gender: '',
  marriageStatus: '',
  childrenCount: '',
  companyName: '',
  companyType: '',
  jobTitle: '',
  jobAddress: '',
  salary: '',
  sentTo: 'banks_leasing',
  additionalSalary: '',
  workPhoneNumber: '',
  socialStatus: '',
  contactName: '',
  contactPhone: '',
  contactType: '',

  noticeActivity: null,
  docScanSocialStatus: null,
  clientPhoto: null,
  docPhoto: null,
  incomeCert: null,
  otherDoc: null
};

export const ADDITIONAL_PRODUCT_CODES = {
  [BankNames.bereke]: {
    insurance: '20', //  Страхование от НС Береке
    kasko_1_8: '32', //  Каско по Береке 1,8%
    kasko_3_0: '322' // Каско по Береке 3,0%
  },
  [BankNames.euBank]: {
    kasko: '21' // Каско СК "Евразия"
  }
} satisfies Partial<Record<BankNames, Record<string, string>>>;

// По коду продукта возвращает поле для радио кнопки
// Нужно, чтобы можно было выбирать только один продукт из предоставленных
export const RADIO_PRODUCTS_FIELD_NAMES: Record<string, string> = {
  [ADDITIONAL_PRODUCT_CODES[BankNames.bereke].kasko_3_0]: 'bereke-kasko',
  [ADDITIONAL_PRODUCT_CODES[BankNames.bereke].kasko_1_8]: 'bereke-kasko'
};
